import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth';
import { Loader2 } from 'lucide-react';

/**
 * Generic login gate for public routes that require any authenticated user.
 * Use RequireAuth from RequireAuth.jsx for admin-only pages.
 */
export default function LoginGate({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-neutral-500">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }
  if (!user) {
    const next = loc.pathname + (loc.search || '');
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return children;
}
